import { observable } from "mobx";


const resources = observable({
    languageId: "en",
    map: null
});

export type ResourceKey = 
    | "Advanced Settings >>"
    | "Already Checked"
    | "Already Inside"
    | "Already Outside"
    | "Already Participated"
    | "Already checked-in"
    | "Apply"
    | "Are you sure?"
    | "Auto"
    | "Auto-Pull Badges"
    | "Auto-Pull Photos"
    | "Badge does not exist"
    | "Badge has been deactivated"
    | "Badge is not collected"
    | "Badge is not valid for current date"
    | "Cancel"
    | "Check badge design and security sticker carefully. If ok, send person to accreditation center. Otherwise collect badge"
    | "Check"
    | "Choose your language:"
    | "Clear"
    | "Close"
    | "Collect badge and send person to accreditation center"
    | "Delete Offline Data"
    | "Delete Offline Photos"
    | "Delete Scanning History (including non-synced)"
    | "Delete Scanning History (only synced)"
    | "Device Name"
    | "Device Registration"
    | "Direction"
    | "Download Offline Badge Data"
    | "Download Offline Photos"
    | "Enable Animations"
    | "Enable Camera Scanning"
    | "Ensure the person is the one indicated on the badge (photo) - if ok scan out and in again"
    | "Enter Password"
    | "Error Screen time (ms)"
    | "Explain that badge is not valid today / Send person to accreditation center"
    | "First check could not be with type out"
    | "Force-Download Offline Badge Data"
    | "Gate Checks"
    | "Gate"
    | "In"
    | "Incorrect Category"
    | "Incorrect Participation Status"
    | "Installation Token"
    | "Installation"
    | "Invalid time range"
    | "Language"
    | "Last Sync Data (version)"
    | "Missing Any Badge Validity"
    | "Missing Badge Entitlement"
    | "Missing Venue"
    | "Missing Zone"
    | "Not assigned to venue"
    | "Not assigned today"
    | "Not valid Participation Status"
    | "Number of Passes Exceeded"
    | "Number of downloaded Badges:"
    | "Offline Mode"
    | "Out"
    | "Password is required for Advanced Settings"
    | "Photos"
    | "Portrait/Landscape"
    | "Register Device"
    | "Registration not allocated"
    | "Registration not found"
    | "Reset App Error"
    | "Scanning History"
    | "Screen expiration time (ms)"
    | "Screen time (ms)"
    | "Send person to accreditation center"
    | "Settings"
    | "Show Action Text"
    | "Show Event Name"
    | "Show Gate Type"
    | "Show Language Selector"
    | "Show Scanning Mode"
    | "Test mode"
    | "URL for server API"
    | "URL should point to API and include Installation Token"
    | "Update Failed"
    | "Use High-Res Photos"
    | "Use different entrance"
    | "Used Storage:"
    | "Venue is not configured for this device"
    | "to be uploaded"
    | "to delete"
    ;

const czechLanguage: { [key in ResourceKey]: string } = {
    "Advanced Settings >>": "Pokročilé Nastavení >>",
    "Already Checked": "Akreditace již byla kontrolovaná",
    "Already Inside": "Již uvnitř",
    "Already Outside": "Již venku",
    "Already Participated": "Již se zúčastnil",
    "Already checked-in": "Již odbaven",
    "Apply": "Uložit",
    "Are you sure?": "Jste si jistý?",
    "Auto": "Auto",
    "Auto-Pull Badges": "Automatické Stažení Akreditací",
    "Auto-Pull Photos": "Automatické Stažení Fotek",
    "Badge does not exist": "Akreditace neexistuje",
    "Badge has been deactivated": "Akreditace byla zrušená",
    "Badge is not collected": "Akreditace nebyla aktivovaná",
    "Badge is not valid for current date": "Akreditace není validní pro dnešní den",
    "Cancel": "Storno",
    "Check badge design and security sticker carefully. If ok, send person to accreditation center. Otherwise collect badge": "Zkontroluj akreditaci. Pokud je v pořádku, pošli osobu do akreditačního centra. Jinak odeber akreditaci.",
    "Check": "Kontrola",
    "Choose your language:": "Vyberte si jazyk:",
    "Clear": "Smazat vše",
    "Close": "Zavřít",
    "Collect badge and send person to accreditation center": "Odeber akreditaci a pošli osobu do akreditačního centra",
    "Delete Offline Data": "Smaž Offline Data",
    "Delete Offline Photos": "Smaž Fotky pro offline mode",
    "Delete Scanning History (including non-synced)": "Smazat Historii Kontrol Akreditací (včetně nesynchronizovaných)",
    "Delete Scanning History (only synced)": "Smazat Historii Kontrol Akreditací (pouze synchronizované)",
    "Device Name": "Název Zařízení",
    "Device Registration": "Registrace zařízení",
    "Direction": "Směr",
    "Download Offline Badge Data": "Stáhni data pro offline mode",
    "Download Offline Photos": "Stáhni fotky pro offline mode",
    "Enable Animations": "Použít animace",
    "Enable Camera Scanning": "Použít kameru ke scannování",
    "Ensure the person is the one indicated on the badge (photo) - if ok scan out and in again": "Zkontroluj majitele akreditace podle fotky - pokud je v pořádku, naskenuj akreditaci ještě jednou",
    "Enter Password": "Vložte heslo",
    "Error Screen time (ms)": "Jak dlouho zobrazit chybu (ms)",
    "Explain that badge is not valid today / Send person to accreditation center": "Vysvětli, že akreditace není dneska validní/Pošli osobu do akreditačního centra",
    "First check could not be with type out": "První kontrola nemůže být typu Ven",
    "Force-Download Offline Badge Data": "Stáhni a přepiš data pro offline mode",
    "Gate Checks": "Počet kontrol akreditací",
    "Gate": "Brána",
    "In": "Dovnitř",
    "Incorrect Category": "Nevalidní kategorie",
    "Incorrect Participation Status": "Nesprávný stav účasti",
    "Installation Token": "Instalační kód",
    "Installation": "Instalace",
    "Invalid time range": "",
    "Language": "Jazyk",
    "Last Sync Data (version)": "Poslední synchronizace dat (verze)",
    "Missing Any Badge Validity": "Chybějící akreditační právo",
    "Missing Badge Entitlement": "Chybějící akreditační právo",
    "Missing Venue": "Chybějící město",
    "Missing Zone": "Chybějící zóna",
    "Not assigned to venue": "Nepřiřazeno k místu konání",
    "Not assigned today": "Pro dnešek nepřiřazeno",
    "Not valid Participation Status": "Neplatný stav účasti",
    "Number of Passes Exceeded": "Nedovolený počet vstupů",
    "Number of downloaded Badges:": "Počet stažených akreditací:",
    "Offline Mode": "Offline Mód",
    "Out": "Ven",
    "Password is required for Advanced Settings": "Heslo je vyžadováno pro Pokročilé Nastavení",
    "Photos": "Fotky",
    "Portrait/Landscape": "Orientace Vertikální/Horizotální",
    "Register Device": "Zaregistruj zařízení",
    "Registration not allocated": "Registrace nepřidělena",
    "Registration not found": "Registrace nenalezena",
    "Reset App Error": "Chyba aplikace",
    "Scanning History": "Historie Kontrol Akreditací",
    "Screen expiration time (ms)": "Screen expiration time (ms)",
    "Screen time (ms)": "Jak dlouho zobrazit kontrolní dialog (ms)",
    "Send person to accreditation center": "Pošli osobu do akreditačního centra",
    "Settings": "Nastavení",
    "Show Action Text": "Zobraz Text Akce",
    "Show Event Name": "Zobraz jméno akce",
    "Show Gate Type": "Zobraz typ vstupu",
    "Show Language Selector": "Zobraz přepínač jazyků",
    "Show Scanning Mode": "Zobraz typ módu",
    "Test mode": "Testovací mód",
    "URL for server API": "URL pro server API",
    "URL should point to API and include Installation Token": "URL musí odkazovat na API a musí obsahovat instalační kód",
    "Update Failed": "Aktualizace selhala",
    "Use High-Res Photos": "Použít obrázky s vysokým rozlišením",
    "Use different entrance": "Použij jiný vstup",
    "Used Storage:": "Použitá velikost disku:",
    "Venue is not configured for this device": "Místo konání není pro toto zařízení nakonfigurováno",
    "to be uploaded": "nesynchronizovaných",
    "to delete": "ke smazání",
};

const germanLanguage: { [key in ResourceKey]: string } = {
    "Advanced Settings >>": "Erweiterte Einstellungen >>",
    "Already Checked": "Bereits benutzt",
    "Already Inside": "Bereits drinnen",
    "Already Outside": "Bereits draußen",
    "Already Participated": "Bereits teilgenommen",
    "Already checked-in": "Bereits eingecheckt",
    "Apply": "Anwenden",
    "Are you sure?": "Sind sie sicher?",
    "Auto": "Auto",
    "Auto-Pull Badges": "Download Akkreditierungen",
    "Auto-Pull Photos": "Download Fotos",
    "Badge does not exist": "Akkreditierung existiert nicht",
    "Badge has been deactivated": "Akkreditierung wurde gesperrt",
    "Badge is not collected": "Akkreditierung ist noch nicht aktiviert",
    "Badge is not valid for current date": "Akkreditierung ist für den heutigen Tag nicht gültig",
    "Cancel": "Abbrechen",
    "Check badge design and security sticker carefully. If ok, send person to accreditation center. Otherwise collect badge": "Überprüfen Sie das Ausweisdesign und den Sicherheitsaufkleber sorgfältig. Wenn ok, schicken Sie die Person zum Akkreditierungszentrum. Ansonsten Abzeichen sammeln",
    "Check": "Kontrolle",
    "Choose your language:": "Wählen sie die Sprache:",
    "Clear": "Löschen",
    "Close": "Scliessen",
    "Collect badge and send person to accreditation center": "Sammeln Sie den Ausweis und schicken Sie die Person zum Akkreditierungszentrum",
    "Delete Offline Data": "Lösche Offline Daten",
    "Delete Offline Photos": "Lösche Offline Fotos",
    "Delete Scanning History (including non-synced)": "Lösche Scan-Historie (inkl. noch nicht synchronisierte)",
    "Delete Scanning History (only synced)": "Lösche Scan-Historie (nur synchronisierte)",
    "Device Name": "Gerätename",
    "Device Registration": "Geräte-Registirerung",
    "Direction": "Richtung",
    "Download Offline Badge Data": "Download Offline Daten",
    "Download Offline Photos": "Download Offline Fotos",
    "Enable Animations": "Animationen Ein",
    "Enable Camera Scanning": "Kamera-Scan Ein",
    "Ensure the person is the one indicated on the badge (photo) - if ok scan out and in again": "Stellen Sie sicher, dass es sich um die Person handelt, die auf dem Ausweis (Foto) angegeben ist - wenn in Ordnung, scannen Sie sie aus und wieder ein",
    "Enter Password": "Passwort eingeben",
    "Error Screen time (ms)": "Zeit für Fehlermeldungen (ms)",
    "Explain that badge is not valid today / Send person to accreditation center": "Erklären Sie, dass der Ausweis heute nicht gültig ist / Schicken Sie die Person zum Akkreditierungszentrum",
    "First check could not be with type out": "Die erste Kontrolle kann nicht vom Typ Out sein",
    "Force-Download Offline Badge Data": "Erzwinge Download von Offline-Daten",
    "Gate Checks": "Eingangskontrollen",
    "Gate": "Eingang",
    "In": "In",
    "Incorrect Category": "Falsche Kategorie",
    "Incorrect Participation Status": "Falscher Teilnahmestatus",
    "Installation Token": "Installations-Code",
    "Installation": "Installation",
    "Invalid time range": "",
    "Language": "Sprache",
    "Last Sync Data (version)": "Letzte Synchronisation (Version)",
    "Missing Any Badge Validity": "Akkreditierung nicht gültig (unbekannter Grund)",
    "Missing Badge Entitlement": "Akkreditierung an diesem Eingang ungültig",
    "Missing Venue": "Akkreditierung an diesem Austragungsort nicht gültig",
    "Missing Zone": "Akkreditierung an diesem Eingang ungültig",
    "Not assigned to venue": "Keinem Austragungsort zugewiesen",
    "Not assigned today": "Heute nicht zugewiesen",
    "Not valid Participation Status": "Ungültiger Teilnahmestatus",
    "Number of Passes Exceeded": "Akkreditierung zu oft benutzt",
    "Number of downloaded Badges:": "Anzahl heruntergeladener Akkreditierungen:",
    "Offline Mode": "Offline Modus",
    "Out": "Out",
    "Password is required for Advanced Settings": "Zum Ändern der erweiterten Einstellungen wird ein Passwort benötigt",
    "Photos": "Fotos",
    "Portrait/Landscape": "Vertikal/Horizontal",
    "Register Device": "Regisriere das Gerät",
    "Registration not allocated": "Registrierung nicht zugewiesen",
    "Registration not found": "Registrierung nicht gefunden",
    "Reset App Error": "App-Fehler zurücksetzen",
    "Scanning History": "Verlauf Kontrollen",
    "Screen expiration time (ms)": "Screen expiration time (ms)",
    "Screen time (ms)": "Anzeigedauer Kontrolle (ms)",
    "Send person to accreditation center": "Person zum Akkreditierungszentrum schicken",
    "Settings": "Einstellungen",
    "Show Action Text": "Zeige empfohlene Aktion",
    "Show Event Name": "Ereignisnamen anzeigen",
    "Show Gate Type": "Tortyp anzeigen",
    "Show Language Selector": "Sprachauswahl anzeigen",
    "Show Scanning Mode": "Scanmodus anzeigen",
    "Test mode": "Test-Modus",
    "URL for server API": "URL für Server-API",
    "URL should point to API and include Installation Token": "Die URL sollte auf die API verweisen und das Installationstoken enthalten",
    "Update Failed": "Update fehlgeschlagen",
    "Use High-Res Photos": "Fotos in hoher Auflösung",
    "Use different entrance": "Anderen Eingang verwenden",
    "Used Storage:": "Speichernutzungx:",
    "Venue is not configured for this device": "Austragungsort ist für dieses Gerät nicht konfiguriert",
    "to be uploaded": "muss noch hochgeladen werden",
    "to delete": "muss noch gelöscht werden",
};

const frenchLanguage: { [key in ResourceKey]: string } = {
    "Advanced Settings >>": "Paramètres avancés >>",
    "Already Checked": "Déjà contrôlé",
    "Already Inside": "Déjà à l'intérieur",
    "Already Outside": "Déjà à l'extérieur",
    "Already Participated": "A déjà participé",
    "Already checked-in": "Déjà enregistré",
    "Apply": "Appliquer",
    "Are you sure?": "Êtes-vous sûr ?",
    "Auto": "Auto",
    "Auto-Pull Badges": "Téléchargement automatique des badges",
    "Auto-Pull Photos": "Téléchargement automatique des photos",
    "Badge does not exist": "Le badge n'existe pas",
    "Badge has been deactivated": "Le badge a été désactivé",
    "Badge is not collected": "Le badge n'a pas été retiré",
    "Badge is not valid for current date": "Le badge n'est pas valide pour la date du jour",
    "Cancel": "Annuler",
    "Check badge design and security sticker carefully. If ok, send person to accreditation center. Otherwise collect badge": "Vérifiez attentivement le design du badge et l'autocollant de sécurité. Si tout est en ordre, envoyez la personne au centre d'accréditation. Sinon, retirez le badge",
    "Check": "Contrôle",
    "Choose your language:": "Choisissez votre langue :",
    "Clear": "Effacer",
    "Close": "Fermer",
    "Collect badge and send person to accreditation center": "Retirez le badge et envoyez la personne au centre d'accréditation",
    "Delete Offline Data": "Supprimer les données hors ligne",
    "Delete Offline Photos": "Supprimer les photos hors ligne",
    "Delete Scanning History (including non-synced)": "Supprimer l'historique des scans (y compris non synchronisés)",
    "Delete Scanning History (only synced)": "Supprimer l'historique des scans (uniquement synchronisés)",
    "Device Name": "Nom de l'appareil",
    "Device Registration": "Enregistrement de l'appareil",
    "Direction": "Direction",
    "Download Offline Badge Data": "Télécharger les données des badges hors ligne",
    "Download Offline Photos": "Télécharger les photos hors ligne",
    "Enable Animations": "Activer les animations",
    "Enable Camera Scanning": "Activer le scan par caméra",
    "Ensure the person is the one indicated on the badge (photo) - if ok scan out and in again": "Assurez-vous que la personne est bien celle indiquée sur le badge (photo) - si c'est le cas, scannez en sortie puis à nouveau en entrée",
    "Enter Password": "Saisir le mot de passe",
    "Error Screen time (ms)": "Durée d'affichage des erreurs (ms)",
    "Explain that badge is not valid today / Send person to accreditation center": "Expliquez que le badge n'est pas valide aujourd'hui / Envoyez la personne au centre d'accréditation",
    "First check could not be with type out": "Le premier contrôle ne peut pas être de type Sortie",
    "Force-Download Offline Badge Data": "Forcer le téléchargement des données des badges hors ligne",
    "Gate Checks": "Contrôles d'entrée",
    "Gate": "Porte",
    "In": "Entrée",
    "Incorrect Category": "Catégorie incorrecte",
    "Incorrect Participation Status": "Statut de participation incorrect",
    "Installation Token": "Code d'installation",
    "Installation": "Installation",
    "Invalid time range": "Plage horaire invalide",
    "Language": "Langue",
    "Last Sync Data (version)": "Dernière synchronisation des données (version)",
    "Missing Any Badge Validity": "Aucune validité de badge",
    "Missing Badge Entitlement": "Droit d'accès du badge manquant",
    "Missing Venue": "Site manquant",
    "Missing Zone": "Zone manquante",
    "Not assigned to venue": "Non affecté à ce site",
    "Not assigned today": "Non affecté aujourd'hui",
    "Not valid Participation Status": "Statut de participation non valide",
    "Number of Passes Exceeded": "Nombre de passages dépassé",
    "Number of downloaded Badges:": "Nombre de badges téléchargés :",
    "Offline Mode": "Mode hors ligne",
    "Out": "Sortie",
    "Password is required for Advanced Settings": "Un mot de passe est requis pour les paramètres avancés",
    "Photos": "Photos",
    "Portrait/Landscape": "Portrait/Paysage",
    "Register Device": "Enregistrer l'appareil",
    "Registration not allocated": "Inscription non attribuée",
    "Registration not found": "Inscription introuvable",
    "Reset App Error": "Réinitialiser l'erreur de l'application",
    "Scanning History": "Historique des scans",
    "Screen expiration time (ms)": "Délai d'expiration de l'écran (ms)",
    "Screen time (ms)": "Durée d'affichage (ms)",
    "Send person to accreditation center": "Envoyez la personne au centre d'accréditation",
    "Settings": "Paramètres",
    "Show Action Text": "Afficher le texte d'action",
    "Show Event Name": "Afficher le nom de l'événement",
    "Show Gate Type": "Afficher le type de porte",
    "Show Language Selector": "Afficher le sélecteur de langue",
    "Show Scanning Mode": "Afficher le mode de scan",
    "Test mode": "Mode test",
    "URL for server API": "URL de l'API du serveur",
    "URL should point to API and include Installation Token": "L'URL doit pointer vers l'API et inclure le code d'installation",
    "Update Failed": "Échec de la mise à jour",
    "Use High-Res Photos": "Utiliser des photos haute résolution",
    "Use different entrance": "Utilisez une autre entrée",
    "Used Storage:": "Stockage utilisé :",
    "Venue is not configured for this device": "Le site n'est pas configuré pour cet appareil",
    "to be uploaded": "à envoyer",
    "to delete": "à supprimer",
};

export const languages = [
    { id: "en", title: "English", map: null, ico: "gb" },
    { id: "cz", title: "Česky", map: czechLanguage, ico: "cz" },
    { id: "de", title: "Deutsch", map: germanLanguage, ico: "de" },
    { id: "fr", title: "French", map: frenchLanguage, ico: "fr" },
];

export function getLanguage(languageId: string) {
    return languages.find(i => i.id === languageId);
}

export function getCurrentLanguage() {
    return languages.find(i => i.id === resources.languageId);
}

export function setCurrentLanguage(id: string) {
    resources.languageId = id || "en";
    resources.map = getCurrentLanguage().map;
}

export function r(key: ResourceKey | string): string {
    if (resources.map === null) {
        return key;
    }
    return resources.map[key] || key;
}
